import { appIconTypes } from "global/enums/appIconTypes";
import { useContext, useEffect, useState } from "react";
import { FrameworkContext } from "../FrameworkContent";
import { ParentContext } from "../ParentContext";

export const useDataModification = () => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataPermissions } = aps_global ?? {}
  const { showOptionsInNavigation } = dataPermissions ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { frInfos, currentSwiperTab, additionalNavigationItems: anis, additionalNavigationPopupItems: anpis } = framework_state ?? {}

  const [additionalNavigationItems, setAdditionalNavigationItems] = useState()

  useEffect(() => {
    if (showOptionsInNavigation) {
      const frInfo = frInfos?.[currentSwiperTab]
      const { navigationOptions } = frInfo ?? {}
      const { pageNavOptions } = navigationOptions ?? {}
      const { dataModification } = pageNavOptions ?? {}

      const navOc = (opts) => {
        framework_handlers.handleShow_itemEdit({ item: currentSwiperTab, type: opts.type })
      };

      const navItem = (type) => ({
        icon: appIconTypes[type],
        caption: _.startCase(type),
        oc: navOc,
        opts: { type, item: currentSwiperTab }
      });

      const navItems = _.compact(
        _.map(dataModification, (dm, dmKey) => {
          if (dm.allow && dmKey !== 'modification') {
            return navItem(dmKey);
          }
          return null;
        })
      );

      setAdditionalNavigationItems(navItems)
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSwiperTab, frInfos]);

  return { additionalNavigationItems: anis, additionalNavigationPopupItems: anpis }

};
